import { Outlet, createFileRoute } from '@tanstack/react-router';

import { useEffect, useRef } from 'react';

import { useAction, useQuery } from 'convex/react';

import { api } from '@/../convex/_generated/api';
import type { BalanceSheetId } from '@/../convex/types';
import { BalanceSheetSidebar } from '@/components/BalanceSheetSidebar';
import { Skeleton } from '@/components/ui/skeleton';
import { AuthenticatedRoute } from '@/lib/authenticatedRoute';

function BalanceSheetLayout() {
  const { id } = Route.useParams() as { id: string };
  const data = useQuery(api.balanceSheets.getById, {
    id: id as BalanceSheetId,
  });
  const ensureMissingRates = useAction(api.fxConversions.ensureMissingRates);
  const fetchingRatesRef = useRef(false);

  useEffect(() => {
    if (
      data?.missingRates &&
      data.missingRates.length > 0 &&
      !fetchingRatesRef.current
    ) {
      fetchingRatesRef.current = true;
      ensureMissingRates({ missingRates: data.missingRates })
        .then(() => {
          console.log('Missing rates fetched successfully');
        })
        .catch(error => {
          console.error('Failed to fetch missing rates:', error);
        })
        .finally(() => {
          fetchingRatesRef.current = false;
        });
    }
  }, [data?.missingRates, ensureMissingRates]);

  return (
    <div className="flex-1 flex gap-6">
      <div className="flex flex-col">
        <div className="pl-10 pt-4">
          {!data && <Skeleton className="h-8 w-48" />}
          {data && (
            <>
              <h1 className="text-2xl font-bold">{data.balanceSheet.name}</h1>
              <p className="text-muted-foreground">Balance Sheet</p>
            </>
          )}
        </div>
        <BalanceSheetSidebar id={id} data={data} />
      </div>
      <main className="flex-1 overflow-auto h-full pr-8">
        <Outlet />
      </main>
    </div>
  );
}

export const Route = createFileRoute('/balance-sheet/$id')({
  component: AuthenticatedRoute(BalanceSheetLayout),
});
